module.exports = __webpack_public_path__ + "static/media/returns-empty.a9d4c6d7.svg";